import React, { useState } from "react";
import { BoxButton, CDialog, Icon } from "shared";
import { Replay } from "@material-ui/icons";

import { useTranslation } from "react-i18next";
import ReopenTreatmentForm from "./ReopenTreatmentForm";

const ReopenTreatment: React.VFC = () => {
  const [isOpen, setOpen] = useState(false);
  const { t } = useTranslation();

  const closeDialog = () => setOpen(false);
  const openDialog = () => setOpen(true);

  return (
    <>
      <BoxButton startIcon={<Icon of={Replay} />} onClick={openDialog}>
        {t("patients.reopen_treatment")}
      </BoxButton>

      <CDialog maxWidth="xs" fullWidth open={isOpen} onClose={closeDialog} aria-labelledby="reopen-treatment">
        <ReopenTreatmentForm onClose={closeDialog} />
      </CDialog>
    </>
  );
};

export default ReopenTreatment;
